import React, { useEffect, useRef } from 'react';
import { StyledContent, StyledIframeContainer } from './styled';
import { M220ReturnsModule } from '~/lib/data-contract';
import { Container } from '../container/container.component';

export type M220ReturnsProps = M220ReturnsModule;

export const M220Returns = ({ shipmondoURL }: M220ReturnsProps) => {
    const url = shipmondoURL ?? 'https://return.shipmondo.com/pwt-dk';
    const scriptParent = useRef<HTMLDivElement | null>(null);
    const script = useRef<HTMLScriptElement | null>(null);

    useEffect(() => {
        // Append the script to the parent element
        // Script will be removed from the DOM when component is unmounted
        if (scriptParent.current && !script.current) {
            script.current = document.createElement('script');
            script.current.src = 'https://plugins.shipmondo.com/returnportal.js';
            script.current.id = 'shipmondo';
            scriptParent.current.appendChild(script.current);
        }
    }, []);

    return (
        <Container hasGutter>
            <StyledIframeContainer ref={scriptParent}>
                <StyledContent className="shipmondo-iframe" data-url={url} />
            </StyledIframeContainer>
        </Container>
    );
};
